import type { ComponentProps, ReactNode } from 'react';
import { GovTooltip } from '@gov-design-system-ce/react';
import { Icon } from '../Icon';

interface InfoTooltipProps {
	content: ReactNode;
	placement?: ComponentProps<typeof GovTooltip>['placement'];
	size?: ComponentProps<(typeof GovTooltip)['Content']>['size'];
}

export const InfoTooltip = ({
	content,
	placement = 'bottom',
}: InfoTooltipProps) => (
	<GovTooltip placement={placement}>
		<GovTooltip.Trigger className="tooltip-trigger">
			<Icon
				name="info-circle"
				type="components"
				size="m"
				color="primary"
			/>
		</GovTooltip.Trigger>
		<GovTooltip.Content size="s">{content}</GovTooltip.Content>
	</GovTooltip>
);
